export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path.startsWith('/tv') || from.path.startsWith('/tv')) {
    to.meta.pageTransition = false
  }
})
